import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AttendanceList } from '@/components/company/attendance/table-view';

const attendanceSearchSchema = z.object({
  status: z.enum(['present', 'absent', 'half_day', 'late', 'leave', 'week_off_day', 'holiday', 'all']).optional().catch('all'),
  page: z.number().optional().catch(1),
  limit: z.number().optional().catch(20),
  search: z.string().optional(),
  startDate: z.string().optional(), // YYYY-MM-DD
  endDate: z.string().optional(), // YYYY-MM-DD
});

export const Route = createFileRoute('/(app)/company/attendance/')({
  component: AttendanceRoute,
  validateSearch: attendanceSearchSchema,
});

function AttendanceRoute() {
  return <AttendanceList />;
}

